import { Provider } from '@angular/core';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader, TranslateHttpLoaderError } from '@ngx-translate/http-loader';
import { reportAssetLoadFailure } from '@shared/helpers/sentry.helper';

// A language file that cannot be fetched (most often a browser that aborted
// the request mid-load) is not a crash: the http-loader falls back to an empty
// dictionary by default (failOnError: false) and the UI renders its
// translation keys. We only route the failure to Sentry, where aborted
// requests become a breadcrumb instead of an issue.
export const reportTranslationLoadFailure = (failure: TranslateHttpLoaderError): void =>
  reportAssetLoadFailure(failure.error, failure.url ?? `i18n/${failure.lang}`);

// Root ngx-translate setup shared by every app (references, configuration,
// feedback, admin). Each app still picks its fallback/current language at
// runtime via setFallbackLang()/use().
export const provideAppTranslations = (): Provider[] =>
  provideTranslateService({
    loader: provideTranslateHttpLoader({
      prefix: './assets/i18n/',
      suffix: '.json',
      onLoadError: reportTranslationLoadFailure
    })
  });
